const relato = (state, data) => {
  data.relatoDenuncia = state.denunciaText;
};
export default {
  relato,
};
